/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const RouteLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M9 20h6.5a4.5 4.5 0 1 0 0-9h-7a2.5 2.5 0 0 1 0-5h6.67a3 3 0 1 0 0-2H8.5a4.5 4.5 0 1 0 0 9h7a2.5 2.5 0 0 1 0 5H9v-3l-5 4 5 4zm8-15a1 1 0 1 1 2 0 1 1 0 0 1-2 0" />
  </Icon>
);
